import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import DashSideBar from "../../shared/DashSideBar";
import "./About.css";
import { Editor } from "primereact/editor";
import Person from "../../Component/AboutDashboard/Person/Person";
import Clients from "../../Component/AboutDashboard/Clients/Clients";

function About() {
  let emptyAboutListContent = {
    id: null,
    title: "",
    description: "",
    sortOrder: null,
  };
  const [AboutListContents, setAboutListContents] = useState(null);

  const [AboutListContentsDialog, setAboutListContentsDialog] = useState(false);
  const [DeleteAboutListContent, setDeleteAboutListContent] = useState(false);
  const [DeleteAboutListContentsDialog, setDeleteAboutListContentsDialog] =
    useState(false);
  const [AboutListContent, setAboutListContent] = useState(
    emptyAboutListContent
  );
  const [selectedAboutListContents, setSelectedAboutListContents] =
    useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);
  const [content, setContent] = useState(""); // Desktop content
  const [content2, setContent2] = useState(""); // Desktop content
  const [aboutcontent, setAboutcontent] = useState(null); // Desktop content object

  const isFetchedAboutList = useRef(false); // ✅ Prevents duplicate API call
  const isFetchedAboutContent = useRef(false); // ✅ Prevents duplicate API call

  useEffect(() => {
    if (!isFetchedAboutList.current) {
      getAboutListContents();
      isFetchedAboutList.current = true; // ✅ Ensure it runs only once
    }
  }, []);

  useEffect(() => {
    if (!isFetchedAboutContent.current) {
      getAboutUsPageContent(); // Load desktop content
      isFetchedAboutContent.current = true; // ✅ Ensure it runs only once
    }
  }, []);
  const getAboutUsPageContent = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Aboutus/getFirstOne"
      );
      if (response.data) {
        const description1 = response.data.description1 || ""; // default to empty string if undefined
        const description2 = response.data.description2 || ""; // default to empty string if undefined

        if (description1 !== content || description2 !== content2) {
          setAboutcontent(response.data);
          setContent(description1); // Set string value
          setContent2(description2); // Set string value
        }
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error Fetching AboutUs Content",
        life: 3000,
      });
    }
  };

  const getAboutListContents = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Aboutus_list_content"
      );

      if (response.data) {
        setAboutListContents(response.data);
      }
    } catch (error) {
      console.error("Error fetching AboutListContents:", error);
    }
  };
  const SaveText = async () => {
    let data = {
      Id: aboutcontent.id,
      Description1: content,
      Description2: content2,
    };
    try {
      const response = await axios.put(
        process.env.REACT_APP_BACKEND_URL + "api/Aboutus/" + aboutcontent.id,
        data
      );

      if (response.data) {
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Content Saved",
          life: 3000,
        });
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Content Not Saved",
          life: 3000,
        });
      }
    } catch (error) {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error Saving Content",
        life: 3000,
      });
    }
  };

  const openNew = () => {
    setAboutListContent(emptyAboutListContent);
    setSubmitted(false);
    setAboutListContentsDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setAboutListContentsDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteAboutListContent(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteAboutListContentsDialog(false);
  };

  const saveAboutus_list_content = async () => {
    setLoading(true);
    setSubmitted(true);

    if (AboutListContent.title.trim()) {
      let _AboutListContents = [...AboutListContents];
      let _AboutListContent = { ...AboutListContent };

      try {
        if (AboutListContent.id) {
          const index = findIndexById(AboutListContent.id);

          let formData = new FormData();
          formData.append("id", AboutListContent.id); // 👈 Make sure to include ID
          formData.append("title", _AboutListContent.title);
          formData.append("description", _AboutListContent.description);
          formData.append("sortOrder", _AboutListContent.sortOrder);

          const response = await axios.put(
            process.env.REACT_APP_BACKEND_URL +
              "api/Aboutus_list_content/" +
              AboutListContent.id,
            formData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.data) {
            _AboutListContents[index] = _AboutListContent;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "List Content Updated",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "List Content Not Updated",
              life: 3000,
            });
          }
        } else {
          _AboutListContent.id = createId();
          let formData = new FormData();
          formData.append("title", _AboutListContent.title);
          formData.append("description", _AboutListContent.description);
          formData.append("sortOrder", _AboutListContent.sortOrder);

          const response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/Aboutus_list_content",
            formData,
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          if (response.data) {
            _AboutListContents.push(response.data);
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "List Content Added",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "List Content Not Added",
              life: 3000,
            });
          }
        }

        setAboutListContents(_AboutListContents);
        setAboutListContentsDialog(false);
        setAboutListContent(emptyAboutListContent);
      } catch (error) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: JSON.stringify(
            error.response ? error.response.data : error.message
          ), // Convert object to string
          life: 3000,
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const editProduct = (AboutListContent) => {
    setAboutListContent({ ...AboutListContent });
    setAboutListContentsDialog(true);
  };

  const confirmDeleteProduct = (AboutListContent) => {
    setAboutListContent(AboutListContent);
    setDeleteAboutListContent(true);
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL +
          "api/Aboutus_list_content/" +
          AboutListContent.id
      );

      setLoading(false);

      if (response.status === 204) {
        // ✅ Check response status instead of data
        let _AboutListContents = AboutListContents.filter(
          (val) => val.id !== AboutListContent.id
        );
        setAboutListContents(_AboutListContents);
        setDeleteAboutListContent(false);
        setAboutListContent(emptyAboutListContent);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "List Content Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "List Content Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < AboutListContents.length; i++) {
      if (AboutListContents[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };
  const handleDescription1Change = (e) => {
    setContent(e.target.value); // Ensure you're passing a string value
  };

  const handleDescription2Change = (e) => {
    setContent2(e.target.value); // Ensure you're passing a string value
  };
  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteAboutListContentsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedAboutListContents.map(
      (AboutListContent) => AboutListContent.id
    );
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL +
        "api/Aboutus_list_content/DeleteByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _AboutListContents = AboutListContents.filter(
        (val) => !selectedAboutListContents.includes(val)
      );
      setAboutListContents(_AboutListContents);
      setDeleteAboutListContentsDialog(false);
      setSelectedAboutListContents(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "List Contents Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "List Contents Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _AboutListContent = { ...AboutListContent };

    _AboutListContent[`${name}`] = val;

    setAboutListContent(_AboutListContent);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage List Contents</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={
            !selectedAboutListContents || !selectedAboutListContents.length
          }
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Project Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveAboutus_list_content}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="AboutListContent-container">
          <div className="titleandsave d-flex justify-content-between">
            <h3>About Us Page Bottom Content</h3>
            <Button
              label="Save"
              icon="pi pi-plus"
              severity="success"
              onClick={SaveText}
            />
          </div>
          <Editor
            id="description1"
            value={content} // This should always be a string
            style={{ height: "100px", marginBottom: "40px" }}
            onTextChange={(e) => {
              handleDescription1Change({ target: { value: e.htmlValue } });
            }}
          />

          <Editor
            id="description2"
            value={content2} // This should always be a string
            style={{ height: "100px", marginBottom: "40px" }}
            onTextChange={(e) => {
              handleDescription2Change({ target: { value: e.htmlValue } });
            }}
          />

          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={AboutListContents}
              selection={selectedAboutListContents}
              onSelectionChange={(e) => setSelectedAboutListContents(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Project Icons"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                field="title"
                header="Title"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                field="sortOrder"
                header="Order"
                sortable
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={AboutListContentsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="AboutListContent Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="title" className="font-bold mb-1">
                Title :
              </label>
              <InputText
                id="title"
                value={AboutListContent.title}
                onChange={(e) => onInputChange(e, "title")}
                required
                className={classNames({
                  "p-invalid": submitted && !AboutListContent.title,
                })}
              />
              {submitted && !AboutListContent.title && (
                <small className="p-error">Title is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="description" className="font-bold mb-1">
                Description :
              </label>
              <Editor
                id="description"
                value={AboutListContent.description}
                style={{ height: "100px" }}
                onTextChange={(e) =>
                  onInputChange(
                    { target: { value: e.htmlValue } },
                    "description"
                  )
                }
                required
                className={classNames({
                  "p-invalid": submitted && !AboutListContent.description,
                })}
              />
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={AboutListContent.sortOrder}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !AboutListContent.sortOrder,
                })}
              />
              {submitted && !AboutListContent.sortOrder && (
                <small className="p-error">Sort Order is required.</small>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={DeleteAboutListContent}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {AboutListContent && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{AboutListContent.title}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={DeleteAboutListContentsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {AboutListContent && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected List Content?
                </p>
              )}
            </div>
          </Dialog>
        </div>
        <Person />
        <Clients />
      </div>
    </div>
  );
}

export default About;
